import { FunctionComponent } from 'react';
import {
  DynamicContents,
  DynamicContentsItem,
} from '../../../../app-kit/components/DynamicContent/types';
import { useFeatureRollout } from '@rea-argonaut/experiment';
import { DynamicContent } from '../../../../app-kit/components/DynamicContent/DynamicContent';
import {
  DynamicContentWrapper,
  FeatureList,
  FeatureListItem,
  InfoList,
  InfoListItem,
} from '../BeforeYouBuyModal.styled';

type BeforeYouBuyModalFeatureListProps = {
  featureList: string[] | null;
  featureListV2: DynamicContents<DynamicContentsItem>[] | null;
};

export const BeforeYouBuyModalFeatureList: FunctionComponent<BeforeYouBuyModalFeatureListProps> = ({
  featureList,
  featureListV2,
}) => {
  const isBYBLegalDisclaimersEnabled = useFeatureRollout('byb_legal_disclaimers').isEnabled();

  return isBYBLegalDisclaimersEnabled ? (
    <FeatureList>
      {featureListV2?.map((feature, index) => (
        <FeatureListItem key={`byb-modal-feature-${index}`}>
          <DynamicContentWrapper>
            <DynamicContent dynamicContents={feature} />
          </DynamicContentWrapper>
        </FeatureListItem>
      ))}
    </FeatureList>
  ) : (
    <InfoList>
      {featureList?.map((feature, index) => (
        <InfoListItem key={`byb-modal-feature-${index}`}>
          <p>{feature}</p>
        </InfoListItem>
      ))}
    </InfoList>
  );
};
